import React from "react";
import UserContext from "./UserContext";

import { ApiHelper } from "./helpers";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Login } from "./Login";
import { Forgot } from "./Forgot";

import { Authenticated } from "./Authenticated";
import { Logout } from "./Logout";
import { CanvaCallback } from "./CanvaCallback";
import ReactGA from "react-ga";
import { EnvironmentHelper } from "./helpers";
import { OrangeKidsPreview } from "./orangePreview/kids";
import { OrangeFLPreview } from "./orangePreview/fl";
import { OrangePTPreview } from "./orangePreview/preteen";
import { DeviceAuthPage } from "./device/DeviceAuthPage";

interface Props { path?: string; }

export const Router = () => {

  const location = useLocation();
  if (EnvironmentHelper.GoogleAnalyticsTag !== "") {
    ReactGA.initialize(EnvironmentHelper.GoogleAnalyticsTag);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  React.useEffect(() => { if (EnvironmentHelper.GoogleAnalyticsTag !== "") ReactGA.pageview(location.pathname + location.search); }, [location]);

  let user = React.useContext(UserContext).userName; //to force rerender on login
  if (user === null) return null;
  return (
    <Routes>
      <Route path="/logout" element={<Logout />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/orangepreview/fl" element={<OrangeFLPreview />} />
      <Route path="/orangepreview/kids" element={<OrangeKidsPreview />} />
      <Route path="/orangepreview/preteen" element={<OrangePTPreview />} />
      <Route path="/canva/callback" element={<CanvaCallback />} />
      <Route path="/device" element={<DeviceAuthPage />} />
      <Route path="/*" element={<PrivateRoute />} />
    </Routes>
  );
};

const PrivateRoute: React.FC<Props> = () => {
  const location = useLocation();
  return (ApiHelper.isAuthenticated)
    ? (<Authenticated />)
    : (<Navigate to="/login" state={{ from: location }} replace />);
};